import React, { useRef, useState } from "react";

import { useNavigate } from "react-router-dom";

import "./SupplierLogin.css";
import supplierPortalService from "../../services/supplierPortalService";



const SupplierLogin = () => {

  const navigate = useNavigate();



  const [mobile, setMobile] = useState("");

  const [otpMode, setOtpMode] = useState(false);

  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [loading, setLoading] = useState(false);
  const [resendLoading, setResendLoading] = useState(false);
  const [error, setError] = useState("");

  const otpRefs = useRef([]);

  const handleSendOtp = async (e) => {
    e.preventDefault();

    const cleanMobile = String(mobile || "")
      .replace(/\D/g, "")
      .slice(0, 10);

    if (cleanMobile.length !== 10) {
      setError("Please enter a valid 10-digit mobile number.");
      return;
    }

    setError("");
    setLoading(true);

    try {
      const response = await supplierPortalService.sendOtp(cleanMobile);

      if (!response?.success) {
        throw new Error(
          response?.message || "Unable to send OTP."
        );
      }

      setMobile(cleanMobile);
      setOtp(["", "", "", "", "", ""]);
      setOtpMode(true);

      setTimeout(() => {
        otpRefs.current[0]?.focus();
      }, 100);
    } catch (err) {
      setError(
        err?.message ||
          "Unable to send OTP. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  const handleOtpChange = (index, value) => {

    const digits = value.replace(/\D/g, "");



    if (!digits) {

      const next = [...otp];

      next[index] = "";

      setOtp(next);

      return;

    }



    const digit = digits.slice(-1);



    const next = [...otp];

    next[index] = digit;

    setOtp(next);



    if (index < 5) {

      otpRefs.current[index + 1]?.focus();

    }

  };



  const handleOtpKeyDown = (index, e) => {

    if (e.key === "Backspace" && !otp[index] && index > 0) {

      otpRefs.current[index - 1]?.focus();

    }

  };



  const handlePaste = (e) => {

    e.preventDefault();



    const value = e.clipboardData

      .getData("text")

      .replace(/\D/g, "")

      .slice(0, 6);



    if (!value) {

      return;

    }



    const next = ["", "", "", "", "", ""];



    value.split("").forEach((digit, index) => {

      next[index] = digit;

    });



    setOtp(next);



    const focusIndex = Math.min(value.length, 5);



    setTimeout(() => {

      otpRefs.current[focusIndex]?.focus();

    }, 50);

  };



  const handleVerifyOtp = async (e) => {
    e.preventDefault();

    const enteredOtp = otp.join("");

    if (enteredOtp.length !== 6) {
      setError("Please enter the complete 6-digit OTP.");
      return;
    }

    setError("");
    setLoading(true);

    try {
      const response = await supplierPortalService.verifyOtp(
        mobile,
        enteredOtp
      );

      if (!response?.access_token) {
        throw new Error(
          response?.message ||
            "OTP verification failed."
        );
      }

      navigate("/supplier/dashboard");
    } catch (err) {
      setError(
        err?.message ||
          "Invalid OTP. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  const handleResendOtp = async () => {
    if (resendLoading || loading) {
      return;
    }

    setError("");
    setResendLoading(true);

    try {
      const response = await supplierPortalService.sendOtp(mobile);

      if (!response?.success) {
        throw new Error(
          response?.message ||
            "Unable to resend OTP."
        );
      }

      setOtp(["", "", "", "", "", ""]);

      setTimeout(() => {
        otpRefs.current[0]?.focus();
      }, 100);
    } catch (err) {
      setError(
        err?.message ||
          "Unable to resend OTP. Please try again."
      );
    } finally {
      setResendLoading(false);
    }
  };

  const changeMobile = () => {
    setOtpMode(false);
    setOtp(["", "", "", "", "", ""]);
    setError("");
  };



  return (

    <div className="supplier-login-page">



      {/* =====================================================

          FULL SCREEN VEHICLE BACKGROUND

      ===================================================== */}



      <img

        className="supplier-background"

        src={`${process.env.PUBLIC_URL}/assets/supplier-fleet-bottom1.png`}

        alt=""

        aria-hidden="true"

      />



      {/* DARK BLUE OVERLAY */}



      <div className="supplier-background-overlay"></div>



      {/* =====================================================

          LEFT CONTENT

      ===================================================== */}



      <section className="supplier-left-content">



        <div className="supplier-brand">



          <div className="supplier-logo-box">

            <img

              className="supplier-logo-image"

              src={`${process.env.PUBLIC_URL}/assets/logo.jpg`}

              alt="Srinivasa Tours & Travels"

            />

          </div>



          <h1>Fleet Management Pro</h1>



          <div className="supplier-brand-subtitle">

            SUPPLIER PORTAL

          </div>



          <div className="supplier-gold-line"></div>



        </div>



        {/* =================================================

            STEPS

        ================================================= */}



        <div className="supplier-steps">



          <div

            className={`supplier-step ${

              !otpMode ? "active" : ""

            }`}

          >

            <span className="supplier-step-dot"></span>



            <span>

              View Statements

            </span>

          </div>



          <div

            className={`supplier-step ${

              otpMode ? "active" : ""

            }`}

          >

            <span className="supplier-step-dot"></span>



            <span>

              Download Documents

            </span>

          </div>



          <div className="supplier-step">



            <span className="supplier-step-dot"></span>



            <span>

              Payment Information

            </span>



          </div>



          <div className="supplier-step">



            <span className="supplier-step-dot"></span>



            <span>

              Supplier Dashboard

            </span>



          </div>



        </div>



        {/* =================================================

            ADDRESS

        ================================================= */}



        <div className="supplier-address">



          <div className="supplier-address-title">

            ADDRESS

          </div>



          <strong>

            Srinivasa Tours &amp; Travels

          </strong>



          <p>

            Plot No.275, CBI Colony, Near Red Water Tank,

            <br />

            NGO's Colony, Vanasthalipuram,

            <br />

            Hyderabad 500070

          </p>



        </div>



      </section>



      {/* =====================================================

          RIGHT LOGIN CONTENT

      ===================================================== */}



      <section className="supplier-right-content">



        <div className="supplier-login-card">



          {/* LOGIN CARD LOGO */}



          <div className="supplier-card-logo">

            <img

              className="supplier-card-logo-image"

              src={`${process.env.PUBLIC_URL}/assets/logo.jpg`}

              alt="Srinivasa Tours & Travels"

            />

          </div>



          {/* =================================================

              MOBILE LOGIN

          ================================================= */}



          {!otpMode ? (

            <>



              <h2>

                Fleet Management Pro

              </h2>



              <div className="supplier-card-subtitle">

                SUPPLIER PORTAL

              </div>



              <div className="supplier-card-divider"></div>



              <h3>

                Login with your registered

              </h3>



              <p className="supplier-card-description">

                Mobile Number

              </p>



              <form onSubmit={handleSendOtp}>



                <label htmlFor="supplier-mobile">

                  Mobile Number

                </label>



                <div className="supplier-mobile-input">



                  <span className="supplier-phone-icon">

                    ☎

                  </span>



                  <input

                    id="supplier-mobile"

                    type="tel"

                    inputMode="numeric"

                    autoComplete="tel"

                    maxLength={10}

                    value={mobile}

                    onChange={(e) => {

                      const value = e.target.value

                        .replace(/\D/g, "")

                        .slice(0, 10);



                      setMobile(value);

                    }}

                    placeholder="Enter mobile number"

                  />



                </div>
                {error && (
                  <div className="supplier-otp-message" role="alert">
                    {error}
                  </div>
                )}

                <button
                  type="submit"
                  className="supplier-primary-btn"
                  disabled={loading}
                >
                  {loading ? "Sending OTP..." : "Send OTP"}
                </button>



              </form>



            



            </>

          ) : (



            <>

              {/* =================================================

                  OTP VERIFICATION

              ================================================= */}



              <h2>

                Verify OTP

              </h2>



              <p className="supplier-card-description">

                Enter OTP sent to

              </p>



              <strong className="supplier-mobile-display">

                +91 {mobile}

              </strong>



              <div className="supplier-change-mobile">



                <span>

                  +91 {mobile}

                </span>



                <button

                  type="button"

                  onClick={changeMobile}

                >

                  Change

                </button>



              </div>



              <label className="otp-label">

                Enter OTP

              </label>



              <div

                className="supplier-otp-boxes"

                onPaste={handlePaste}

              >



                {otp.map((digit, index) => (



                  <input

                    key={index}

                    ref={(element) => {

                      otpRefs.current[index] = element;

                    }}

                    type="text"

                    inputMode="numeric"

                    autoComplete="one-time-code"

                    maxLength={1}

                    value={digit}

                    onChange={(e) =>

                      handleOtpChange(

                        index,

                        e.target.value

                      )

                    }

                    onKeyDown={(e) =>

                      handleOtpKeyDown(index, e)

                    }

                    aria-label={`OTP digit ${index + 1}`}

                  />



                ))}



              </div>



              <div className="supplier-otp-message">

                OTP sent to +91 {mobile}

              </div>
              {error && (
                <div className="supplier-otp-message" role="alert">
                  {error}
                </div>
              )}

              <button
                type="button"
                className="supplier-primary-btn"
                onClick={handleVerifyOtp}
                disabled={loading}
              >
                {loading ? "Verifying..." : "Verify OTP"}
              </button>

              <button
                type="button"
                className="supplier-resend"
                onClick={handleResendOtp}
                disabled={resendLoading || loading}
              >
                {resendLoading ? "Sending..." : "Resend OTP"}
              </button>



              <button

                type="button"

                className="supplier-back-link"

                onClick={changeMobile}

              >

                ← Change Mobile Number

              </button>



            </>

          )}



        </div>



      </section>



    </div>

  );

};



export default SupplierLogin;